<template>
  <div class="admin">
    <div v-if="!isQuestionnaire" class="d-flex flex-row" style="background: white;">
      <div v-if="currentUser" id="sidebar" :class="showSidebar ? '' : 'hide'">
        <SideBar v-if="showSidebar ? 'hide' : ''"/>
      </div>
      
      <div class="container-fluid" style="background: #f4f4f5; padding: 0">
        <TopBar v-if="currentUser" msg="이거슨 제일 위에에요"/>
        
        <div style="background: #f4f4f5; padding: 20px;" :style="{ 'padding': currentUser ? '20px' : '0' }">
          <router-view></router-view>
          <Footer v-if="currentUser" msg="이그시 푸터"/>
        </div>
      </div>
    </div>
    <!--설문지페이지인 경우--->
    <div v-else class="d-flex flex-row" style="background: white;">
      <div class="container-fluid" style="background: #f4f4f5; padding: 0">
        <router-view></router-view>
      </div>
    </div>
  </div> <!--admin end--->
</template>

<script>
// @ is an alias to /src
import TopBar from '@/components/TopBar.vue'
import SideBar from '@/components/survey/SurveySideBar.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'survey',
  components: {
    TopBar,
    SideBar,
    Footer
  },
  computed: {
    currentUser() {
      console.log(this.$route.name);
      return this.$store.getters['auth/currentUser'];
    },
    isQuestionnaire() {
      return this.$route.name == 'surveyQuestionnaire';
    }
  },
  data() {
    return {
      showSidebar: true,
    };
  },
  methods: {
    toggleSidebar() {
      this.showSidebar = !this.showSidebar;
    },
  },
}
</script>